import cx from 'classnames';

import uploadSvg from 'assets/icons/upload.svg';
import SvgIcon from 'lib/SvgIcon';

const DisplayInputFileUpload = ({
  isShowDropArea,
  isEffectiveDisabled,
  placeholder,
  isDragActive,
}: {
  isShowDropArea: boolean;
  isEffectiveDisabled: boolean;
  placeholder: string;
  isDragActive: boolean;
}): React.ReactElement => {
  return (
    <div
      className={cx('grid grid-flow-col border border-neutral-300 rounded-md px-4 py-2', {
        'h-[100px] border-dashed border-2 rounded-lg': isShowDropArea,
        'opacity-70': isEffectiveDisabled,
      })}
    >
      {isDragActive ? (
        <p>Drop files here...</p>
      ) : (
        <div className="body-base text-neutral-600 truncate">{placeholder}</div>
      )}
      <SvgIcon
        src={uploadSvg}
        className="fill-current h-[18px] w-[18px] justify-self-end text-neutral-500 hover:text-purple-800"
      />
    </div>
  );
};

export default DisplayInputFileUpload;
